import React from "react";
import { getUserDetails } from "../content/axiosConfig.js";

const HeaderUser = () => {
  const user = getUserDetails() || {};
  const { FullName = "Super User", Email = "" } = user;

  return (
    <div className="donezo-header-user">
      <div className="donezo-user-info">
        <div className="donezo-user-name">{FullName}</div>
        <div className="donezo-user-email">{Email}</div>
      </div>
    </div>
  );
};

export default HeaderUser;
